import React, { useEffect, useState } from 'react';
import { Navigate, BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import ScrollToTop from './components/ScrollToTop/ScrollToTop.jsx';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Departments from './pages/Departments/Departments';
// import NewsEvents from './pages/NewsEvents/NewsEvents';
import Posts from './pages/Posts/Posts';
import OurTeam from './pages/OurTeam/OurTeam';
import AdminOurTeam from './pages/AdminOurTeam/AdminOurTeam';
import AdminEditOurTeam from './pages/AdminEditOurTeam/AdminEditOurTeam';
import Achievements from './pages/Achievements/Achievements';
import FinanceAccounts from './pages/FinanceAccounts/FinanceAccounts';
import Gallery from './pages/Gallery/Gallery';
import Contact from './pages/Contact/Contact';
import Feedback from './pages/Feedback/Feedback';
import Topbar from './components/Topbar/Topbar';
import Footer from './components/Footer/Footer';
import Health from './pages/Health/Health.js';
import Education from './pages/Education/Education.js';
import Agriculture from './pages/Agriculture/Agriculture.js';
import YouthSports from './pages/YouthSports/YouthSports.js';
import SecuritySafety from './pages/SecuritySafety/SecuritySafety.js';
import Infrastructure from './pages/Infrastructure/Infrastructure.js';
import Login from './pages/Login/Login.js';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard.js';
import AdminPosts from './pages/AdminPosts/AdminPosts.js';
import Signup from './pages/Signup/Signup.js';
import ConfirmOTP from './pages/ConfirmOTP/ConfirmOTP.js';
import UserProfile from './pages/UserProfile/UserProfile.js';
import Unauthorized from './pages/Unauthorized/Unauthorized.js';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword.js';
import ResetPassword from './pages/ResetPassword/ResetPassword.js';
import AdminUsers from './pages/AdminUsers/AdminUsers.js';
import EditUser from './pages/EditUser/EditUser.js';
import AdminEditUser from './pages/AdminEditUser/AdminEditUser.js';
// import AdminEvent from './pages/AdminEvent/AdminEvent.js';
import AdminPost from './pages/AdminPost/AdminPost.js';
import CreateFeedback from './pages/CreateFeedback/CreateFeedback.js';
import AdminFeedbacks from './pages/AdminFeedbacks/AdminFeedbacks.js';
import AdminFeedback from './pages/AdminFeedback/AdminFeedback.js';
import AdminUserProfile from './pages/AdminUserProfile/AdminUserProfile.js';
import AdminReport from './pages/AdminReport/AdminReport.js';
import AdminReports from './pages/AdminReports/AdminReports.js';
import AddToTeam from './pages/AddToTeam/AddToTeam.js';
import CreateReport from './pages/CreateReport/CreateReport.js';
import AdminEditReport from './pages/AdminEditReport/AdminEditReport.js';
import Reports from './pages/Reports/Reports.js';
import Report from './pages/Report/Report.js';
import CreateForm from './pages/CreateForm/CreateForm.js';
import AdminForms from './pages/AdminForms/AdminForms.js';
import AdminForm from './pages/AdminForm/AdminForm.js';
import AdminEditForm from './pages/AdminEditForm/AdminEditForm.js';
import SubmitForm from './pages/SubmitForm/SubmitForm.js';
import AdminApplications from './pages/AdminApplications/AdminApplications.js';
import AdminApplication from './pages/AdminApplication/AdminApplication.js';
import Applications from './pages/Applications/Applications.js';
import Application from './pages/Application/Application.js';
import AdministrativeStructure from './pages/AdministrativeStructure/AdministrativeStructure.js';
import Administration from './pages/Administration/Administration.js';
import WorksHousing from './pages/WorksHousing/WorksHousing.js';
import PlanningPRS from './pages/PlanningPRS/PlanningPRS.js';
import WASH from './pages/WASH/WASH.js';
import MTDP from './pages/MTDP/MTDP.js';
import OngoingProjects from './pages/OngoingProjects/OngoingProjects.js';
import PublicServices from './pages/PublicServices/PublicServices.js';
import TenderProcurement from './pages/TenderProcurement/TenderProcurement.js';
import CommunityEngagement from './pages/CommunityEngagement/CommunityEngagement.js';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy.js';
import ScrollButton from './components/ScrollButton/ScrollButton.jsx';
import AdminEditPost from './pages/AdminEditPost/AdminEditPost.js';
import CreatePost from './pages/CreatePost/CreatePost.js';
import Post from './pages/Post/Post.js';
import AddToGallery from './pages/AddToGallery/AddToGallery.js';
import AdminGallery from './pages/AdminGallery/AdminGallery.js';
import AdminEditGallery from './pages/AdminEditGallery/AdminEditGallery.js';


const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const [loading, setLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const checkAccess = () => {
      try {
        const token = localStorage.getItem('token');
        const userRoles = JSON.parse(localStorage.getItem('userRoles')) || [];

        if (!token) {
          throw new Error('Token missing');
        }

        // Decode the JWT (naively without verifying signature)
        const payloadBase64 = token.split('.')[1];
        const decodedPayload = JSON.parse(atob(payloadBase64));

        // Check if token is expired
        const currentTime = Math.floor(Date.now() / 1000);
        if (decodedPayload.exp && decodedPayload.exp < currentTime) {
          throw new Error('Token expired');
        }

        // Check if roles are allowed
        const hasAccess =
          allowedRoles.length === 0 ||
          userRoles.some(role => allowedRoles.includes(role));

        if (!hasAccess) {
          throw new Error('Unauthorized role');
        }

        setIsAllowed(true);
      } catch (error) {
        console.warn('Access check failed:', error.message);
        localStorage.removeItem('token');
        localStorage.removeItem('userRoles');
        localStorage.removeItem('userId');
        setIsAllowed(null);
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [allowedRoles]);

  if (loading) return null;

  if (isAllowed === null) {
    return <Navigate to="/login" replace />;
  }

  if (!isAllowed) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};


function App() {
  return (
    <Router>
      <Topbar />
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/departments" element={<Departments />} />
        {/* <Route path="/news-events" element={<NewsEvents />} /> */}
        <Route path="/admin-our-team" element={<AdminOurTeam />} />
        <Route path="/admin-edit-our-team/:id" element={<AdminEditOurTeam />} />
        <Route path="/our-team" element={<OurTeam />} />
        <Route path="/posts" element={<Posts />} />
        <Route path="/achievements" element={<Achievements />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/mtdp" element={<MTDP />} />
        <Route path="/ongoing-projects" element={<OngoingProjects />} />
        <Route path="/public-services" element={<PublicServices />} />
        <Route path="/tender-procurement" element={<TenderProcurement />} />
        <Route path="/community-engagement" element={<CommunityEngagement />} />
        <Route path="/planning-prs" element={<PlanningPRS />} />
        <Route path="/works-housing" element={<WorksHousing />} />
        <Route path="/finance-accounts" element={<FinanceAccounts />} />
        <Route path="/health" element={<Health />} />
        <Route path="/administration" element={<Administration />} />
        <Route path="/wash" element={<WASH />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/add-to-gallery" element={<ProtectedRoute allowedRoles={['admin']}><AddToGallery /></ProtectedRoute>} />
        <Route path="/admin-gallery" element={<ProtectedRoute allowedRoles={['admin', 'events & media']}><AdminGallery /></ProtectedRoute>} />
        <Route path="/admin-edit-gallery/:id" element={<ProtectedRoute allowedRoles={['admin', 'events & media']}><AdminEditGallery /></ProtectedRoute>} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/education" element={<Education />} />
        <Route path="/agriculture" element={<Agriculture />} />
        <Route path="/youth-sports" element={<YouthSports />} />
        <Route path="/security-safety" element={<SecuritySafety />} />
        <Route path="/infrastructure" element={<Infrastructure />} />
        <Route path="/sign-up" element={<Signup />} />
        <Route path="/confirm-otp/:userId" element={<ConfirmOTP />} />
        <Route path="/reset-password/:userId" element={<ResetPassword />} />
        <Route path="/user-profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
        <Route path="/edit-user/:id" element={<EditUser />} />
        <Route path="/admin-edit-user/:id" element={<ProtectedRoute allowedRoles={['admin']}><AdminEditUser /></ProtectedRoute>} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/admin-dashboard" element={<ProtectedRoute allowedRoles={['admin', 'events & media', 'education', 'health', 'security', 'agriculture', 'wash', 'works', 'finance']}><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin-users" element={<ProtectedRoute allowedRoles={['admin']}><AdminUsers /></ProtectedRoute>} />
        <Route path="/admin-user-profile/:id" element={<ProtectedRoute allowedRoles={['admin']}><AdminUserProfile /></ProtectedRoute>} />
        <Route path="/create-post" element={<ProtectedRoute allowedRoles={['admin', 'events & media', 'education', 'health', 'security', 'agriculture', 'wash', 'works', 'finance']}><CreatePost /></ProtectedRoute>} />
        <Route path="/create-feedback" element={<ProtectedRoute allowedRoles={['user', 'admin']}><CreateFeedback /></ProtectedRoute>} />
        <Route path="/admin-feedbacks" element={<ProtectedRoute allowedRoles={['admin']}><AdminFeedbacks /></ProtectedRoute>} />
        <Route path="/admin-feedback/:id" element={<ProtectedRoute allowedRoles={['admin']}><AdminFeedback /></ProtectedRoute>} />
        <Route path="/post/:id" element={<Post />} />
        <Route path="/admin-posts" element={<ProtectedRoute allowedRoles={['admin', 'events & media', 'education', 'health', 'security', 'agriculture', 'wash', 'works', 'finance']}><AdminPosts /></ProtectedRoute>} />
        <Route path="/admin-post/:id" element={<ProtectedRoute allowedRoles={['admin', 'events & media', 'education', 'health', 'security', 'agriculture', 'wash', 'works', 'finance']}><AdminPost /></ProtectedRoute>} />
        {/* <Route path="/admin-event/:id" element={<ProtectedRoute allowedRoles={['admin', 'events & media']}><AdminEvent /></ProtectedRoute>} /> */}
        <Route path="/admin-edit-post/:id" element={<ProtectedRoute allowedRoles={['admin', 'events & media', 'education', 'health', 'security', 'agriculture', 'wash', 'works', 'finance']}><AdminEditPost /></ProtectedRoute>} />
        <Route path="/add-to-team" element={<ProtectedRoute allowedRoles={['admin']}><AddToTeam /></ProtectedRoute>} />
        <Route path="/create-report" element={<ProtectedRoute allowedRoles={['admin']}><CreateReport /></ProtectedRoute>} />
        <Route path="/admin-reports" element={<ProtectedRoute allowedRoles={['admin']}><AdminReports /></ProtectedRoute>} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/report/:id" element={<Report />} />
        <Route path="/admin-report/:id" element={<ProtectedRoute allowedRoles={['admin']}><AdminReport /></ProtectedRoute>} />
        <Route path="/admin-edit-report/:id" element={<ProtectedRoute allowedRoles={['admin']}><AdminEditReport /></ProtectedRoute>} />
        <Route path="/create-form" element={<ProtectedRoute allowedRoles={['admin']}><CreateForm /></ProtectedRoute>} />
        <Route path="/admin-forms" element={<ProtectedRoute allowedRoles={['admin']}><AdminForms /></ProtectedRoute>} />
        <Route path="/admin-form/:id" element={<ProtectedRoute allowedRoles={['admin']}><AdminForm /></ProtectedRoute>} />
        <Route path="/admin-edit-form/:id" element={<ProtectedRoute allowedRoles={['admin']}><AdminEditForm /></ProtectedRoute>} />
        <Route path="/submit-form/:id" element={<ProtectedRoute allowedRoles={['admin', 'user']}><SubmitForm /></ProtectedRoute>} />
        <Route path="/admin-applications" element={<ProtectedRoute allowedRoles={['admin']}><AdminApplications /></ProtectedRoute>} />
        <Route path="/admin-application/:id" element={<ProtectedRoute allowedRoles={['admin']}><AdminApplication /></ProtectedRoute>} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/administrative-structure" element={<AdministrativeStructure />} />
        <Route path="/application/:id" element={<Application />} />
      </Routes>
      <ScrollButton />
      <Footer />
    </Router>
  );
}

export default App;